(function(doc, win) {
    var fun = function(doc, win) {
        var docEl = doc.documentElement,
            resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
            recalc = function() {
                var clientWidth = docEl.clientWidth;
                if (!clientWidth) return;
                docEl.style.fontSize = 27 * (clientWidth / 540) + 'px'; //基于540px的宽度设置1rem=27px；
            };

        if (!doc.addEventListener) return;
        win.addEventListener(resizeEvt, recalc, false);
        doc.addEventListener('DOMContentLoaded', recalc, false);
    }
    fun(document, window);

})(document, window);


// WEBPACK FOOTER //
// ./src/config/rem.js